export default "__VITE_ASSET__a9d1788e__"